import type { Props } from './Svg'
import { Svg } from './Svg'

export function CheckedInShield(props: Props) {
  return (
    <Svg width="16" height="21" fill="none" strokeWidth="0" {...props}>
      <path
        fill="currentColor"
        d="M8 21 .8 15.6A1.98 1.98 0 0 1 0 14V2C0 1.45.2.98.59.59.98.19 1.45 0 2 0h12c.55 0 1.02.2 1.41.59.4.39.59.86.59 1.41v12a1.99 1.99 0 0 1-.8 1.6L8 21Zm0-2.5 6-4.5V2H2v12l6 4.5ZM6.95 13l5.65-5.65-1.4-1.45-4.25 4.25-2.1-2.1-1.45 1.4L6.95 13Z"
      />
    </Svg>
  )
}
